import { CDN_ORIGIN } from '@/utils/publicMediaUrl'
import { assetCardThumbnailUrl } from '../../volc-asset/assetMedia'
import { assetMediaType } from './assetLibrarySelection'
import { referenceThumbnailUrl } from './referenceThumbnails'

const LIBRARY_IMAGE_PROCESS = 'image/resize,m_lfit,w_320,h_320/quality,q_75/format,webp'
const LIBRARY_VIDEO_PROCESS = 'video/snapshot,t_0,f_jpg,w_320,h_0,m_fast'

// 320px covers the roughly 160px dialog cards at 2x density. Never load originals.
// Keep this presentation URL separate from the asset used for preview/generation.
export function assetLibraryThumbnailUrl(item) {
  const type = assetMediaType(item)
  if (type !== 'image' && type !== 'video') return ''
  const sources = [item.thumbnailSourceUrl, item.coverUrl, item.mediaUrl, item.sourceUrl, item.localUrl, item.url]
  for (const source of sources) {
    try {
      const url = new URL(source)
      if (url.origin === CDN_ORIGIN && !url.username && !url.password && !url.hash &&
        [...url.searchParams.keys()].length === 1 && url.searchParams.get('x-oss-process') === LIBRARY_IMAGE_PROCESS) return source
    } catch (_) { /* Try the existing validated CDN source resolver below. */ }
    const thumbnail = assetCardThumbnailUrl({ sourceUrl: source, assetType: type === 'image' ? 'Image' : undefined })
    if (thumbnail) return `${thumbnail.split('?')[0]}?x-oss-process=${LIBRARY_IMAGE_PROCESS}`
  }
  if (type === 'video') {
    for (const source of sources) {
      const thumbnail = referenceThumbnailUrl(source, 'video')
      if (thumbnail && new URL(thumbnail).origin === CDN_ORIGIN) return `${thumbnail.split('?')[0]}?x-oss-process=${LIBRARY_VIDEO_PROCESS}`
    }
  }
  return ''
}
